/**
 * This module contains the checks to gate features to be enabled only under specific conditions.
 */

import { User } from './types/User';

/**
 * Returns true iff a user profile represents a Plentiful-internal user.
 */
export function isInternalProfile(profile: Pick<User, 'email_verified' | 'email'>): boolean {
  return (
    !!profile.email_verified &&
    !!profile.email &&
    ((email: string) => {
      const matches = email.match(/\@plentiful.org/);
      return !!matches && matches.length > 0;
    })(profile.email)
  );
}
